<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div>
        <div class="box-body">
          <div class="row">
            <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
              <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
            </div>
          </div>
          <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
            <div class="col-sm-12">
              <div class="col-sm-2" style="width:20%">
                <label>Geographic Area</label>
                <select
                  v-model="salesdata.region"
                  required
                  name="region"
                  class="form-control"
                  @change="fiteredResult($event, 'region')"
                >
                  <option value="" disabled>Select G.A</option>
                  <option
                    v-for="(item,index) in region_list"
                    :key="index"
                    :value="item.key"
                    id="region"
                  >{{item.value}}</option>
                </select>
              </div>
              <div class="col-sm-2" style="width:20%">
                <label>Location</label>
                <select
                  v-model="salesdata.site"
                  required
                  name="site"
                  class="form-control"
                  @change="fiteredResult($event, 'site')"
                >
                  <option value="" disabled>Select Location</option>
                  <option
                    v-for="(item,index) in site_list"
                    :key="index"
                    v-bind:value="item._id"
                    id="site"
                  >{{item.siteName}}</option>
                </select>
              </div>
              <div class="col-sm-2" style="width:20%">
                <label>On</label>
                <date-picker
                  id="startDate"
                  v-model="from"
                  lang="en"
                  name="startDate"
                  input-class="form-control"
                  width="100%"
                  use-utc="true"
                  format="DD-MM-YYYY"
                  @change="fiteredResult($event, 'startDate')"
                ></date-picker>
              </div>
              <div class="col-sm-2" style="margin-top:23px">
                <button class="btn btn-default" style="text-align:left" @click="clear">Clear</button>
                <router-link :to="{ name: 'salesdataCreate' }">
                  <button class="btn btn addbtn" >Add New</button>
                </router-link>
              </div>
            </div>
          </vue-form>
          <br>
          <v-server-table
            ref="salesdataTable"
            url
            :columns="columns"
            :options="options"
            @loaded="onLoaded"
          >
            <template slot="beforeBody">
              <tr v-if="loading" class="VueTables__no-results">
                <td class="text-center" colspan="6">
                  <pulse-loader></pulse-loader>
                </td>
              </tr>
            </template>
            <template slot="action" slot-scope="props">
            <div>
              <a class="fa fa-edit" role="button" v-on:click.stop="action(props.row)"></a>
            </div>
          </template>
          </v-server-table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import { formService, eventBus, salesdataService } from '../../../services';
import { EVENTS } from '../../../config';
import moment from 'moment';
import {mapState} from 'vuex';

export default {
  name: 'salesdata',
  data() {
    return {
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: EVENTS,
      formstate: {},
      from: {},
      to: {},
      region_list: {},
      parameters: [],
      site_list: {},
      salesdata: {},
      // dateInput:'',
      USER_ROLES: USER_ROLES,
      loading: null,
      salesdataTable: null,
      columns: ['reportedDate', 'totalValue', 'region', 'site', 'action'],
      options: {
        highlightMatches: true,
        headings: {
          reportedDate: 'Date',
          totalValue: 'Total Quantity (kg)',
          region: 'Geographic Area',
          site: 'Location',
          action: 'Action',
        },
        filterable : false,
        templates: {
          reportedDate(row, query) {
            return moment(query.reportedDate).format('DD-MM-YYYY');
          },
          region(row, query) {
            return `${query.regionName}`;
          },
          site(row,query){
            return `${query.siteSiteName}`
          }
        },
        requestFunction: request => {
          this.parameters.$page = request.page;
          this.parameters.$limit = request.limit;
          if(this.user.roleName == "GA Head"){
            this.parameters.regionRegionManager = this.user._id
          }
          this.loading = true;
          return this.$salesdataDataRepository
            .list(this.parameters)
            .catch(error => {
              console.error('salesdata.requestFunction-error:', error);
              this.$snotify.error('Get Status', 'Error!');
            });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total,
          };
        },
      },
    };
  },
  mounted: function() {
    this.getRegion();
    this.getSite();
  },
  methods: {
    fieldClassName: formService.fieldClassName,
    clear(){
      this.salesdata.site ='',
      this.salesdata.region ='',
      this.salesdata.reportedDate ='',
      delete this.parameters['region'];
      delete this.parameters['site'];
      delete this.parameters['reportedDate']; 
      this.$refs.salesdataTable.refresh();
    },
    getRegion() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      
      let regionlist = [];
      this.$regionDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            regionlist = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.name,
              };
            });
          }
          this.region_list = regionlist;
        })
        .catch(error => {
          this.loading = false;
          console.error('Region.requestFunction-error:', error);
          this.$snotify.error('Get region list failed', 'Error!');
        });
    },
    salesdataDetails(row) {
      this.$router.push({
        name: 'salesdataDetails',
        params: {
          _id: row._id,
        },
        props: row,
      });
    },
    fiteredResult(s, targetItem) {
      // delete this.parameters['region'];
      // delete this.parameters['site'];
      // delete this.parameters['reportedDate'];

      if (targetItem == 'region' && event.target.value) {
        this.parameters = {
          ...this.parameters,
          region: event.target.value,
        };
      }
      if (targetItem == 'site' && event.target.value) {
        this.parameters = {
          ...this.parameters,
          site: event.target.value,
        };
      }

      if (targetItem == 'startDate' && event.target.title) {
        console.log('event.target.title', this.from.toISOString());
        this.parameters = {
          ...this.parameters,
          reportedDate: this.from.toISOString(),
        };
      }
      this.$refs.salesdataTable.refresh();
    },
    getSite() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      let sitelist = [];
      this.$siteDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            sitelist = res.data.docs;
          }
          this.site_list = sitelist;
          console.log('site_list', this.site_list);
          console.log(
            'dhfgeugfs',
            this.site_list.map(item => {
              item._id;
            }),
          );
        })
        .catch(error => {
          this.loading = false;
          console.error('Site.requestFunction-error:', error);
          this.$snotify.error('Get site list failed', 'Error!');
        });
    },
    action(row) {

      this.$router.push({
          name: 'SalesdataDetails',
          params: {
            _id: row._id,
          },
          props: row,
        });
      // if (this.user.roleName == "GA Head"){
      //   this.dateInput = moment(row.createdAt).format('DD/MM/YYYY')
      //   console.log("gfhefgj",this.dateInput)
      //   this.getValidDate(this.dateInput,7,row)
      // }
      // else if (this.user.roleName == "Sales Manager"){
      //   this.dateInput = moment(row.createdAt).format('DD/MM/YYYY')
      //   console.log("gfhefgj",this.dateInput)
      //   this.getValidDate(this.dateInput,3,row)
      // }
      // else if (this.user.roleName == "Sales Representative"){
      //   this.getTodayValidTime(6,18,row)
      // }
    },
    // getValidDate(dateInput, validationDays,row){
    //   let userDate = new Date(dateInput);   
    //   let differentInTime = Date.now() - userDate.getTime();  
    //   let differentInDays = Math.floor(differentInTime / (1000*3600*24)); 
    //   if (validationDays && validationDays >= differentInDays ) {
    //       this.$router.push({
    //       name: 'SalesdataDetails',
    //       params: {
    //         _id: row._id,
    //       },
    //       props: row,
    //     });
    //   }else {
    //       this.$snotify.error("Cannot edit the Sales Data","Error!")
    //   }
    // },
    // getTodayValidTime(startTime, endTime,row) {
    //     let today = new Date().getHours();
    //     if (today >= startTime && today <= endTime) {
    //       this.$router.push({
    //         name: 'SalesdataDetails',
    //         params: {
    //           _id: row._id,
    //         },
    //         props: row,
    //       });  
    //     }
    //     else{
    //       this.$snotify.error("Cannot edit the Sales Data",'Error')
    //     }
    // },
    onLoaded() {
      this.salesdataTable = this.$refs.salesdataTable;
    },
  },
  computed: {
    ...mapState({
          user: state => state.auth.user
    }),
  },
};
</script>

<style scoped>
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
.addbtn{
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
  color: white
}
</style>



// WEBPACK FOOTER //
// salesdata.vue?5b9537ee